import React, { useState, useRef, useEffect } from "react";
import classnames from "classnames";

import { getLocationById, ILocation } from "../../api";
import { LOCATIONLITERAL, PROVINCE } from "../../constant";

import styles from "./Location.module.css";

interface Props {
  updateCity: (id: number) => void;
  updateCounty: (id: number) => void;
  updateProvince: (id: number) => void;
}

function Location(props: Props) {
  const { updateCity, updateCounty, updateProvince } = props;

  const [active, setActive] = useState(LOCATIONLITERAL["EMPTY"].value);

  const [city, setCity] = useState<ILocation[]>([]);
  const [district, setDistrict] = useState<ILocation[]>([]);

  const [provinceSelected, setProvinceSelected] = useState(-1);
  const [provinceText, setProvinceText] = useState("全国");
  const [citySelected, setCitySelected] = useState(-1);
  const [cityText, setCityText] = useState(LOCATIONLITERAL["EMPTY"].value);
  const [districtSelected, setDistrictSelected] = useState(-1);
  const [districtText, setDistrictText] = useState(
    LOCATIONLITERAL["EMPTY"].value
  );

  const areaRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const clickOutside = (event: MouseEvent) => {
      const { target } = event;
      if (
        !(areaRef.current as HTMLDivElement).contains(target as HTMLDivElement)
      ) {
        setActive(LOCATIONLITERAL["EMPTY"].value);
      }
    };

    window.addEventListener("mousedown", clickOutside);
    return () => {
      window.removeEventListener("mousedown", clickOutside);
    };
  }, []);

  useEffect(() => {
    getLocationById(provinceSelected).then(response => {
      const name = provinceSelected < 5 ? "全市" : "全省";
      setCity([{ id: -1, name }, ...response]);
      setCityText(name);
    });
    updateProvince(provinceSelected);
    updateCity(-1);
    updateCounty(-1);
    // eslint-disable-next-line
  }, [provinceSelected]);

  useEffect(() => {
    getLocationById(citySelected).then(response => {
      const name = "全市";
      setDistrict([{ id: -1, name }, ...response]);
      setDistrictText("全市");
    });
    updateCity(citySelected);
    updateCounty(-1);
    // eslint-disable-next-line
  }, [citySelected]);

  useEffect(() => {
    updateCounty(districtSelected);
    // eslint-disable-next-line
  }, [districtSelected]);

  return (
    <div className={styles.container}>
      <div className={styles.label}>所在地</div>
      <div className={styles.value}>
        <div className={styles.area} ref={areaRef}>
          <dl
            className={classnames(styles.dl, styles.province, {
              [styles.drop]: active === LOCATIONLITERAL["PROVINCE"].value
            })}
          >
            <dt
              className={styles.dt}
              onClick={() =>
                setActive(
                  active === LOCATIONLITERAL["PROVINCE"].value
                    ? LOCATIONLITERAL["EMPTY"].value
                    : LOCATIONLITERAL["PROVINCE"].value
                )
              }
            >
              <em className={styles.text}>{provinceText}</em>
              <i className={styles.icon}></i>
            </dt>
            <dd className={styles.dd} clstag="pageclick|keycount|pcshop_LotLocation">
              {PROVINCE.map((item, index) => {
                const { id, name } = item;
                return (
                  <b
                    className={styles.item}
                    onClick={() => {
                      setActive(LOCATIONLITERAL["EMPTY"].value);
                      setProvinceText(name);
                      setProvinceSelected(id);
                      setCityText("");
                      setCitySelected(-1);
                    }}
                    key={index}
                  >
                    {name}
                  </b>
                );
              })}
            </dd>
          </dl>
          {provinceSelected > 0 && (
            <dl
              className={classnames(styles.dl, styles.city, {
                [styles.drop]: active === LOCATIONLITERAL["CITY"].value
              })}
              style={{
                width:
                  cityText.length - 5 > 0
                    ? (cityText.length - 5) * 12 + 110
                    : LOCATIONLITERAL["EMPTY"].value
              }}
            >
              <dt
                className={styles.dt}
                onClick={() =>
                  setActive(
                    active === LOCATIONLITERAL["CITY"].value
                      ? LOCATIONLITERAL["EMPTY"].value
                      : LOCATIONLITERAL["CITY"].value
                  )
                }
              >
                <em className={styles.text}>{cityText}</em>
                <i className={styles.icon}></i>
              </dt>
              <dd className={styles.dd} clstag="pageclick|keycount|pcshop_LotLocation">
                {city.map((item, index) => {
                  const { id, name } = item;
                  return (
                    <b
                      className={styles.item}
                      onClick={() => {
                        setActive(LOCATIONLITERAL["EMPTY"].value);
                        setCityText(name);
                        setCitySelected(id);
                      }}
                      key={index}
                    >
                      {name}
                    </b>
                  );
                })}
              </dd>
            </dl>
          )}
          {citySelected > 0 && provinceSelected > 4 && (
            <dl
              className={classnames(styles.dl, styles.district, {
                [styles.drop]: active === LOCATIONLITERAL["DISTRICT"].value
              })}
              style={{
                width:
                  districtText.length - 5 > 0
                    ? (districtText.length - 5) * 12 + 110
                    : LOCATIONLITERAL["EMPTY"].value
              }}
            >
              <dt
                className={styles.dt}
                onClick={() =>
                  setActive(
                    active === LOCATIONLITERAL["DISTRICT"].value
                      ? LOCATIONLITERAL["EMPTY"].value
                      : LOCATIONLITERAL["DISTRICT"].value
                  )
                }
              >
                <em className={styles.text}>{districtText}</em>
                <i className={styles.icon}></i>
              </dt>
              <dd className={styles.dd} clstag="pageclick|keycount|pcshop_LotLocation">
                {district.map((item, index) => {
                  const { id, name } = item;
                  return (
                    <b
                      className={styles.item}
                      onClick={() => {
                        setActive(LOCATIONLITERAL["EMPTY"].value);
                        setDistrictText(name);
                        setDistrictSelected(id);
                      }}
                      key={index}
                    >
                      {name}
                    </b>
                  );
                })}
              </dd>
            </dl>
          )}
        </div>
      </div>
    </div>
  );
}

export default Location;
